import {Image} from "@/types";

export type WhyUsType = {
    id: number;
    title: string;
    description: string;
    image: Image;
}


export const whyUs: WhyUsType[] = [
    {
        id: 1,
        title: 'Skilled Operators',
        description: 'Experienced crew',
        image: {
            id: 1,
            url: '/images/why-us/why1.svg',
            original: '/images/why-us/why1.svg',
            title: 'excavation operators',
        }
    },
    {
        id: 2,
        title: 'Modern Equipment',
        description: 'Well maintained',
        image: {
            id: 2,
            url: '/images/why-us/why2.svg',
            original: '/images/why-us/why2.svg',
            title: 'excavation machinery',
        }
    },
    {
        id: 3,
        title: 'Safety First',
        description: 'High standards',
        image: {
            id: 3,
            url: '/images/why-us/why3.svg',
            original: '/images/why-us/why3.svg',
            title: 'safe excavation',
        }
    },
    {
        id: 4,
        title: 'Tight Access',
        description: 'Narrow sites',
        image: {
            id: 4,
            url: '/images/why-us/why4.svg',
            original: '/images/why-us/why4.svg',
            title: 'mini excavation',
        }
    },
    {
        id: 5,
        title: 'All Projects',
        description: 'Big or small',
        image: {
            id: 5,
            url: '/images/why-us/why5.svg',
            original: '/images/why-us/why5.svg',
            title: 'residential commercial excavation',
        }
    },
    {
        id: 6,
        title: 'Reliable Service',
        description: 'On time work',
        image: {
            id: 6,
            url: '/images/why-us/why6.svg',
            original: '/images/why-us/why6.svg',
            title: 'excavation services',
        }
    }
];




